import { FC, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, useTheme } from '@mui/material'
import { useHistory } from 'react-router'
import { useQuery } from 'packages/core'
import { EidWorkflow } from 'packages/eid-ui'
import config from 'config'
import { Icon } from 'packages/eid-icons'
import { handleRenderWorkflow } from 'utils'

export type EidWorkflowButtonProps = {
    name: string
    title: string
    path: string
    mobile?: boolean
    iconName: string
    customStyles?: React.CSSProperties
    disabled?: any
}

export const EidWorkflowButton: FC<EidWorkflowButtonProps> = (props) => {
    const { t } = useTranslation()

    const theme = useTheme()
    const query = useQuery()
    const history = useHistory()

    const onClick = () => {
        handleRenderWorkflow([], props.name, history)
    }

    if (props.mobile) {
        return (
            <EidWorkflow
                title={t(props.title)}
                baseEidUrl={config.BASE_EID_URL}
                workflowName={props.name}
            >
                <Box
                    sx={{
                        minHeight: '40px',
                        borderRadius: '4px',
                        border: `solid 1px ${theme?.palette?.primary?.main}`,
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: theme?.palette?.common?.white,
                        color: theme?.palette?.primary?.main,
                        fontSize: '16px',
                        padding: theme.spacing(1),
                        cursor: 'pointer',
                        '&:hover': {
                            boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.15)',
                        },
                        ...props.customStyles,
                    }}
                >
                    <Box
                        sx={{
                            minWidth: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        +
                    </Box>
                    <Box
                        sx={{
                            width: '90%',
                            overflowWrap: 'break-word',
                        }}
                    >
                        {t(props.title)}
                    </Box>
                </Box>
            </EidWorkflow>
        )
    }
    return (
        <Fragment>
            <Box
                component="button"
                type="button"
                disabled={!!props.disabled}
                aria-disabled={!!props.disabled || undefined}
                sx={{
                    minHeight: '40px',
                    borderRadius: '4px',
                    border: `solid 1px ${theme?.palette?.primary?.main}`,
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: theme?.palette?.common?.white,
                    color: theme?.palette?.primary?.main,
                    fontSize: '16px',
                    padding: theme.spacing(1),
                    cursor: 'pointer',
                    width: '100%',
                    textAlign: 'left',
                    '&:hover': {
                        boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.15)',
                    },
                    ...props.customStyles,
                    ...(props.disabled && {
                        backgroundColor: '#ebebed',
                        cursor: 'no-drop',
                        '&:hover': {
                            boxShadow: 'none',
                        },
                    }),
                }}
                onClick={props.disabled ? undefined : onClick}
            >
                {props.iconName ? (
                    <Icon
                        name={props.iconName}
                        style={{
                            minWidth: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    />
                ) : (
                    <Box
                        sx={{
                            minWidth: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        +
                    </Box>
                )}
                <Box
                    sx={{
                        width: '90%',
                        overflowWrap: 'break-word',
                    }}
                >
                    {t(props.title)}
                </Box>
            </Box>
        </Fragment>
    )
}
